import React from 'react';
import './Spinner.scss';

export function Spinner() {
    return (
        <div className='spinner'>
            <div className='spinner__item'></div>
        </div>
    )
}
